const defaultSettings = {
    rent: {
        dayCountType: "INCLUSIVE"
    },
    region: {
        defaultRegion: 'ua',
        regions: ['ua', 'ge', 'pl', 'az']
    },
    currency: {
        regionDefaultCurrency: 'UAH',
        baseCurrency: 'UAH',
        currencies: ['UAH', 'USD', 'EUR'],
        currencyOptions: [
            { value: 'UAH', label: 'UAH' },
            { value: 'USD', label: 'USD' },
            { value: 'EUR', label: 'EUR' }
        ],
        currencySymbol: { UAH: '₴', USD: '$', EUR: '€', GEL: '₾', PLN: 'zł', AZN: '₼' },
        currencyPairs: { 
            UAH: ['USD', 'EUR'], 
            USD: ['UAH', 'EUR'], 
            EUR: ['UAH', 'USD']
        },
        currencyImportantPairs: { 
            USD: ['UAH'], 
            EUR: ['UAH'] 
        },
        currencyToRegion: { UAH: 'ua', USD: 'us', EUR: 'eu', GEL: 'ge', PLN: 'pl', AZN: 'az' },
        currencyBalancePreset: { UAH: 0, USD: 0, EUR: 0 }    
    },
    validation: {
        phoneMask: '+99 (999) 999-99-99',
        phonePrefix: '+38',
        phoneStandardE164: false
    }
}

export default defaultSettings
